module.exports = __webpack_public_path__ + "static/media/scroll2.de7824a3.png";